export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const GET_PROFILE = "GET_PROFILE";
export const CLEAR_CURRENT_USER = "CLEAR_CURRENT_USER";
export const PROFILE_LOADING = "PROFILE_LOADING";
export const PROFILE_NOT_FOUND = "PROFILE_NOT_FOUND";
export const GET_POST = "GET_POST";
export const GET_POSTS = "GET_POSTS";
export const ADD_POST = "ADD_POST";
export const POST_LOADING = "POST_LOADING";
export const DELETE_POST = "DELETE_POST";
